import React from 'react';
import { Typography } from '@mui/material';
import { Description, FilterAlt, ViewList } from '@mui/icons-material';
import InfoCards from '@/components/common/InfoCards';


const InfoPaymentSection: React.FC = () => {
    return (
        <InfoCards
            layout="stacked"
            stackSpacing={{ xs: 2, sm: 2.5, md:3 }}
            containerMargin={{ xs: 3, sm: 4, md: 6, lg: 8 }}
            
            cards={[
                {
                    icon: <ViewList />,
                    iconColor: 'secondary.main',
                    title: 'Ver Historial Completo',
                    content: (
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                                fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.875rem' },
                                textAlign: 'left',
                                width: '100%'
                            }}
                        >
                            <>• Consulta todos los pagos realizados con información detallada<br /></>
                            <>• Fecha y hora de transacción<br /></>
                            <>• Concepto pagado<br /></>
                            <>• Monto y método de pago<br /></>
                            <>• Estado actual (Exitoso, Pendiente, Rechazado)</>
                        </Typography>
                    ),
                    useIconBox: true
                },
                {
                    icon: <FilterAlt />,
                    iconColor: 'primary.dark',
                    title: 'Filtrar Transacciones',
                    content: (
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                                fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.875rem' },
                                textAlign: 'left',
                                width: '100%'
                            }}
                        >
                            <>• Encuentra rápidamente lo que buscas:<br /></>
                            <>• Por rango de fechas<br /></>
                            <>• Por concepto (matrícula, pensión, certificados)<br /></>
                            <>• Por estado de pago</>
                        </Typography>
                    ),
                    useIconBox: true
                },
                {
                    icon: <Description />,
                    iconColor: 'primary.main',
                    title: 'Exportar a Excel',
                    content: (
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                                fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.875rem' },
                                textAlign: 'left',
                                width: '100%'
                            }}
                        >
                            <>• Descarga reportes personalizados en formato .xlsx con:<br /></>
                            <>• Todos los registros o selección filtrada<br /></>
                            <>• Columnas: Fecha, Concepto, Valor, Estado, Referencia<br /></>
                            <>• Listo para presentar o archivar</>
                        </Typography>
                    ),
                    useIconBox: true
                }
            ]}
        />
    );
};

export default InfoPaymentSection;